const OPEN_CLASS = 'is-open';

export function initializeNavigation() {
  const navigation = document.querySelector('[data-navigation]');
  const toggle = document.querySelector('[data-navigation-toggle]');

  if (!navigation || !toggle) {
    return;
  }

  const closeNavigation = () => {
    navigation.classList.remove(OPEN_CLASS);
    toggle.setAttribute('aria-expanded', 'false');
  };

  toggle.addEventListener('click', () => {
    const isOpen = navigation.classList.toggle(OPEN_CLASS);
    toggle.setAttribute('aria-expanded', String(isOpen));
  });

  navigation.addEventListener('click', (event) => {
    if (event.target.closest('a')) {
      closeNavigation();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeNavigation();
      toggle.focus();
    }
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 48rem)').matches) {
      closeNavigation();
    }
  });
}

